<template>
	<section v-if="props" class="hero hero-center" :class="{heroHome : heroHome}">
		<a href="#" class="arrow-down" v-in-viewport="{}" v-scroll-to="'#section'"></a>
		<div v-if="(props.background_video___desktop.value) && (!this.$breakpoints.isMobile())" class="hero-video-mask">
			<div class="overlay-gradient" ></div>
			<video autoloop loop autoplay muted preload="metadata">
				<source :src="props.background_video___desktop.value">
				</video>
				<div class="hero-title-container">
					<div class="container-fluid fullwidth" :class="{'text-center' : heroHome }">
						<div class="inside">
							<h1 class="headline" v-if="props.header_title" v-in-viewport="{}">
								<span class="splitted" id="splitWord"></span>
								{{props.header_title.value}}
							</h1>
							<h3 class="subheadline" v-if="props.header_description" v-in-viewport="{}">{{props.header_description.value}}</h3>



							<a class="btn_orange" v-if="lightbox" @click="showModal()">
								Watch video
							</a>

						</div>
					</div>
				</div>
				<span class="toTop" ref="toTop"></span>
			</div>

			<div v-else="this.$breakpoints.isMobile()" class="hero-image-mask">
				<div class="hero-title-container">
					<div class="inside">
						<div class="container-fluid fullwidth" :class="{'text-center' : heroHome }">
							<h1 class="headline" v-if="props.header_title" v-in-viewport="{}">
								<span class="splitted" id="splitWord"></span>
								{{props.header_title.value}}
							</h1>
							<h3 class="subheadline" v-if="props.header_description" v-in-viewport="{}">{{props.header_description.value}}</h3>

							<a class="btn_orange" v-if="lightbox" @click="showModal()">
								Watch video
							</a>
						</div>
					</div>
				</div>
				<template v-if="props.background_image___desktop.value" class="">
					<div class="overlay-gradient"></div>
					<div v-if="props.background_image___desktop.value[0]" class="hero-image hidden-xs " :style="setBackgroundImage(props.background_image___desktop.value[0].url)"></div>
					<div v-if="props.background_image___mobile.value[0]" class="hero-image hidden-sm" :style="setBackgroundImage(props.background_image___mobile.value[0].url)"></div>
				</template>
			</div>

			<modal name="LightboxVideo" :adaptive="true" :height="'auto'"  :width="1100" v-if="lightbox" @before-open="beforeOpen" @before-close="beforeClose">



				<div class="embed-container">
					<div slot="top-right" class="top-right">
						<button @click="$modal.hide('LightboxVideo')">
										
						</button>
					</div>
 				 <iframe :src="'https://player.vimeo.com/video/'+props.vimeo_id.value+'?autoplay=1&loop=1&title=0&byline=0&portrait=0&api=1'" width="800" height="450" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
 			 </div>

			</modal>
		</section>
	</template>


	<script>
		require('../assets/img/arrow-down.svg');
		require('../assets/img/close.svg');
		require('../assets/img/agile.svg');


		import commons from '../mixins/common.js';

		export default{
			name:'Hero',
			props: ['props', 'heroHome','splitted','auxIndex','lightbox'],
			mixins:[commons],
			computed:{
				animatedWord: function(){
					if (typeof this.props !== 'undefined'){
						if (typeof this.props.animated_words_for_header_title !== 'undefined'){
							let str = this.props.animated_words_for_header_title.value;
							return str.split(',');
						}
					}
				}
			},
			mounted:function(){
				if (typeof this.props !== 'undefined'){
					if (typeof this.props.animated_words_for_header_title !== 'undefined'){
						this.animateWords();
					}
				}
			},
			methods:{

				showModal: function () {
				this.$modal.show('LightboxVideo');
			  },
			  hideModal: function () {
			    this.$modal.hide('LightboxVideo');
			  },
				beforeOpen (event) {
		      console.log(event)
		      // Set the opening time of the modal
		      this.time = Date.now()
					document.body.classList.add('open-lightbox');
		    },
		    beforeClose (event) {
		      console.log(event)
		      // If modal was open less then 5000 ms - prevent closing it
		      if (this.time + this.duration < Date.now()) {
		        event.stop()
		      }
					document.body.classList.remove('open-lightbox')
		    },
				animateWords: function(){
					for (var i=0; i < this.animatedWord.length; i++){
						var node = document.createElement('b');
						node.insertAdjacentHTML( 'beforeend', this.animatedWord[i] );
						document.getElementById('splitWord').appendChild(node);
					}

					var numberOfItems = this.animatedWord.length;
					var currentItem = 0;

					//show first item
					$('.splitted b').removeClass('is-visible');

					//loop through the items
					var infiniteLoop = setInterval(function(){
						$('.splitted b').removeClass('is-visible');

						if(currentItem == numberOfItems -1){
							currentItem = 0;
						}else{
							currentItem++;
						}
						//$('.splitted b').removeClass('is-visible');
						$('.splitted b').eq(currentItem).addClass('is-visible');
					}, 3000);
				}
			}
		}
	</script>



// WEBPACK FOOTER //
// hero.vue?0e7a1912